import { EyeIcon, EyeOffIcon } from 'lucide-react';

export function ShowHideAll({
  onClickShowAll,
  onClickHideAll,
}: {
  onClickShowAll: React.MouseEventHandler<HTMLButtonElement>;
  onClickHideAll: React.MouseEventHandler<HTMLButtonElement>;
}) {
  return (
    <div className="flex w-full flex-row px-1">
      <button
        type="button"
        onClick={onClickShowAll}
        className="flex w-1/2 items-center justify-between gap-2 rounded-l-sm border-2 border-emerald-500 bg-emerald-500 px-4 py-2 text-white transition-colors hover:bg-emerald-400 focus:ring-2 focus:ring-emerald-300"
      >
        Show All <EyeIcon />
      </button>
      <button
        type="button"
        onClick={onClickHideAll}
        className="flex w-1/2 items-center justify-between gap-2 rounded-r-sm border-2 border-emerald-500 bg-white px-4 py-2 text-emerald-500 transition-colors hover:bg-emerald-50 focus:ring-2 focus:ring-emerald-300"
      >
        Hide All <EyeOffIcon />
      </button>
    </div>
  );
}
